import { get, groupBy, includes, isEmpty, map, values } from 'lodash'

import { INGREDIENT_KEYWORD_SUBTYPES } from '../constants'

const buildIngredientKeywordTree = ({
  keywordTree,
  keywordType,
  parentKey = '',
  parentPath = '',
  parentId = null,
  keyPath = [],
  level = 1,
  skipCategoryCreation = false,
}) =>
  map(keywordTree, (item, index) => {
    const nodeKey = isEmpty(parentKey) ? `${index}` : `${parentKey}-${index}`

    const nodePath = isEmpty(parentPath)
      ? `[${index}]`
      : `${parentPath}.children[${index}]`

    const nodeKeyPath = isEmpty(keyPath)
      ? [`${index}`]
      : [...keyPath, `${parentKey}-${index}`]

    const childrenLevel = level + 1

    const keywordItem = {
      ...item,
      key: nodeKey,
      path: nodePath,
      keyPath: nodeKeyPath,
      parentId,
      parentPath,
      level,
      children: [],
      allowedOperations: keywordType.allowedOperations,
    }

    if (keywordItem.level === 6) {
      return keywordItem
    }

    if (includes([3, 5], childrenLevel) && !skipCategoryCreation) {
      const categoryArray =
        childrenLevel === 3
          ? values(INGREDIENT_KEYWORD_SUBTYPES)
          : get(INGREDIENT_KEYWORD_SUBTYPES, `${item.subtype}.childrenKeyTypes`)

      const subtypeChildrenNodes = map(categoryArray, ({ id, term }) => ({
        id: `${item.id}-${id}`,
        term,
        subtype: id,
        type: item.type,
        children: [],
        isSubtype: true,
        ingredientId: item.ingredientId,
        allowedOperations: keywordType.allowedOperations,
      }))

      if (isEmpty(item.children)) {
        return {
          ...keywordItem,
          children: buildIngredientKeywordTree({
            keywordTree: subtypeChildrenNodes,
            keywordType,
            parentId: item.id,
            parentKey: nodeKey,
            parentPath: nodePath,
            keyPath: nodeKeyPath,
            level: childrenLevel,
          }),
        }
      }

      const itemChildrenGroupedBySubType = groupBy(item.children, 'subtype')

      const subtypeChildrenNodesWithChildren = map(
        subtypeChildrenNodes,
        subtypeChildNode => {
          const subtypeChildDirectChildren = get(
            itemChildrenGroupedBySubType,
            subtypeChildNode.subtype,
          )

          return {
            ...subtypeChildNode,
            children: subtypeChildDirectChildren,
          }
        },
      )

      return {
        ...keywordItem,
        children: buildIngredientKeywordTree({
          keywordTree: subtypeChildrenNodesWithChildren,
          keywordType,
          parentId: item.id,
          parentKey: nodeKey,
          parentPath: nodePath,
          keyPath: nodeKeyPath,
          level: childrenLevel,
        }),
      }
    }

    return {
      ...keywordItem,
      children: buildIngredientKeywordTree({
        keywordTree: item.children,
        keywordType,
        parentId: item.id,
        parentKey: nodeKey,
        parentPath: nodePath,
        keyPath: nodeKeyPath,
        level: childrenLevel,
        skipCategoryCreation,
      }),
    }
  })

export default buildIngredientKeywordTree
